import React from "react";
import { Classes } from "jss";
import { mohLogoUrl, nzGovtLogoUrl } from "../../assets/images";
import { Link } from "./Link";
import { withStyles, createStyles, Theme } from "@material-ui/core";

interface Link {
  url: string;
  label: string;
}

type Props = {
  classes: Classes;
  links: [Link, Link];
};

const styles = (theme: Theme) =>
  createStyles({
    footer: {
      alignItems: "center",
      backgroundColor: "#F5F5F5",
      display: "flex",
      flexFlow: "row wrap",
      justifyContent: "space-between",
      padding: theme.spacing(2),
      width: "100%"
    },
    footerLink: {
      margin: `${theme.spacing(2)}px !important` // Prevent MUI overriding this
    },
    footerLinks: {
      display: "flex",
      flexGrow: 1,
      justifyContent: "center"
    },
    footerLogos: {
      alignItems: "center",
      display: "flex",
      flexGrow: 1,
      justifyContent: "center"
    },
    footerLogo: {
      margin: theme.spacing(2)
    }
  });

const Footer = ({ classes, links }: Props) => (
  <footer className={classes.footer}>
    <div className={classes.footerLinks}>
      <Link
        id={links[0].label}
        className={classes.footerLink}
        url={links[0].url}
        label={links[0].label}
      />
      <Link
        id={links[1].label}
        className={classes.footerLink}
        url={links[1].url}
        label={links[1].label}
      />
    </div>
    <div className={classes.footerLogos}>
      <img
        alt="Ministry of Health"
        className={classes.footerLogo}
        height={40}
        id="moh-logo"
        src={mohLogoUrl}
      />
      <img
        alt="New Zealand Government"
        className={classes.footerLogo}
        id="nz-govt-logo"
        height={20}
        src={nzGovtLogoUrl}
      />
    </div>
  </footer>
);

const styled = withStyles(styles)(Footer);
export { styled as Footer };
